// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TyTU","tabsBox":"styles_tabsBox__BS8ua","createButton":"styles_createButton__13anf"};